import { Component } from '@angular/core';

@Component({
  selector: 'api-overview-skeleton-loader',
  templateUrl: './api-overview-skeleton-loader.component.html',
  standalone: false,
})
export class ApiOverviewSkeletonLoaderComponent {}
